import { Box, Checkbox, FormControl } from "@primer/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/ui/button";
import Modal from "../../../components/ui/modal";
import ModalActions from "../../../components/ui/modal/ModalActions";
import Text from "../../../components/ui/text";
import TextInput from "../../../components/ui/text-input";
import { useCommonContext } from "../../../contexts/common";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { actions } from "../../../state/actions/actionsWrapper";
import { RootState } from "../../../state/reducers";
import { IFoMonAnChiTiet } from "../../../models/response/thuc-don/IFoMonAnChiTiet";

const DangKyMonAnEditModal = () => {
  const { status, editingData } = useSelector(
    (x: RootState) => x.thucDonWrapper.monAnChiTiet
  );
  const dispatch = useDispatch();
  const { dm_coso_id } = useCommonSelectedHook();
  const { translate } = useCommonContext();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<IFoMonAnChiTiet>({
    defaultValues: editingData
      ? {
          ...editingData,
        }
      : undefined,
  });
  const onSubmit = async (data: any) => {
    dispatch(
      actions.thucDonWrapper.monAnChiTiet.SAVE_START({
        ...data,
        id: data?.id ?? 0,
        ten_mon_an: data?.ten_mon_an ?? '',
        ten_mon_an_en: data?.ten_mon_an_en ?? '',
        calo: data?.calo ?? 0,
        dm_coso_id:dm_coso_id
      })
    );
  };

  return (
    <Modal
      isOpen
      title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
      onClose={() => {
        dispatch(
          actions.thucDonWrapper.monAnChiTiet.CLOSE_EDIT_MODAL(undefined)
        );
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ display: "grid", gap: 2 }}>
          <FormControl>
            <FormControl.Label>
              <Text text="Tên món ăn (Vi)" />
            </FormControl.Label>
            <TextInput
              block
              name="ten_mon_an"
              register={register}
              errors={errors}
              required
              validateMessage={`${translate(
                "Base.Form.RequiredMessage"
              )} ${translate("DangKyMonAn.Name")}`}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>
              <Text text="Tên món ăn (En)" />
            </FormControl.Label>
            <TextInput
              block
              name="ten_mon_an_en"
              register={register}
              errors={errors}
              required
              validateMessage={`${translate(
                "Base.Form.RequiredMessage"
              )} ${translate("DangKyMonAn.NameEn")}`}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>
              <Text text="Calo" />
            </FormControl.Label>
            <TextInput
              block
              type="number"
              name="calo"
              register={register}
              errors={errors}
              required
              validateMessage={`${translate(
                "Base.Form.RequiredMessage"
              )} ${translate("DangKyMonAn.Calo")}`}
            />
          </FormControl>
          <FormControl>
            <FormControl.Label>
              <Text text="Thứ tự hiển thị" />
            </FormControl.Label>
            <TextInput
              block
              type="number"
              name="idx_order"
              register={register}
              errors={errors}
              required
              validateMessage={`${translate(
                "Base.Form.RequiredMessage"
              )} ${translate("DangKyMonAn.idx_order")}`}
            />
          </FormControl>
          {/* <FormControl>
                        <FormControl.Label><Text text='DangKyMonAnType.Name' /></FormControl.Label>
                        <ComboboxDangKyMonAnType
                            width={'100%'}
                            value={watch("dm_DangKyMonAn_type_id", editingData?.dm_DangKyMonAn_type_id)}
                            onValueChanged={(value) => setValue("dm_DangKyMonAn_type_id", value)}
                        />

                    </FormControl>
                    <FormControl>
                        <FormControl.Label><Text text='Code' /></FormControl.Label>
                        <TextInput block
                            name="viet_tat"
                            register={register}
                            errors={errors}
                            required
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Show campaign</FormControl.Label>
                        <Checkbox checked={watch("is_show_campaign", editingData?.is_show_campaign)}
                            onChange={(e) => {
                                setValue("is_show_campaign", e.target.checked)
                            }}
                        />
                    </FormControl> */}
        </Box>

        <ModalActions>
          <Button
            text="Base.Label.Close"
            onClick={() => {
              dispatch(
                actions.thucDonWrapper.monAnChiTiet.CLOSE_EDIT_MODAL(undefined)
              );
            }}
          />
          <Button
            text="Base.Label.Update"
            variant="primary"
            type="submit"
            isLoading={status === ePageBaseStatus.is_saving}
          />
        </ModalActions>
      </form>
    </Modal>
  );
};

export default DangKyMonAnEditModal;
